import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ProfileUpdateEvent {
  prenom: string;
  nom: string;
  photo?: string;
}

@Injectable({ providedIn: 'root' })
export class ProfileUpdateService {
  private profileUpdated = new Subject<ProfileUpdateEvent>();

  /** Emit this when the user saves their profile or uploads a new photo */
  emitProfileUpdate(event: ProfileUpdateEvent): void {
    this.profileUpdated.next(event);
  }

  /** Subscribe to profile-change events in other components (e.g. Sidebar) */
  get profileUpdated$() {
    return this.profileUpdated.asObservable();
  }
}
